import styled from 'styled-components';

export const AdditionalAccountInfoContainer = styled.div`
    display: flex;
    padding: 20px;
    flex-grow: 0;
    flex-shrink: 0;
    @media screen and (max-width: 740px){
      flex-direction: column;
    }
`;

export const AccountIdentifierContainer = styled.div`
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 30%;
    border-right: solid 1px #d4d4d4;
    position: relative;
    padding-right:10px;
    @media screen and (max-width: 740px){
      border-bottom: solid 1px #d4d4d4;
      border-right: none;
      padding:0px 0px 10px 10px;
  }
`;

export const SegmentationContainer = styled.div`
    padding:0px 0px 0px 20px;
    flex-grow: 0;
    flex-shrink: 0;
    flex:1;
    border-right: solid 1px #d4d4d4;
    position: relative;
    @media screen and (max-width: 740px){
      border-bottom: solid 1px #d4d4d4;
      border-right: none;
      padding:10px;
    }
`;

export const BookOfBusinessContainer = styled.div`
    padding:0px 0px 0px 20px;
    flex-grow: 0;
    flex-shrink: 0;
    flex:1;
    border-right: solid 1px #d4d4d4;
    position: relative;
    @media screen and (max-width: 740px){
      border-bottom: solid 1px #d4d4d4;
      border-right: none;
      padding:10px;
    }
`;

export const AccountNotesContainer = styled.div`
    padding:0px 0px 0px 20px;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 30%;
    position: relative;
    @media screen and (max-width: 740px){
      border-right: none;
      padding:10px;
    }
`;

export const EditContainer = styled.div`
  margin-top:35px;
  
`;

export const CSREditLinkToPillContainer = styled.a`
    position: absolute;
    bottom: 0px;
    @media screen and (max-width: 740px){
      margin-bottom: 10px;
    }
`;

export const DataContainer = styled.div`

`;

export const AdditionalAccountInfoContentContainer = styled.div`
  display: flex;
`;

export const AdditionalAccountInfoContent = styled.div`
  position: relative;
`;

export const FundSummaryLabel = styled.div`

`;

export const FundSummaryData = styled.div`

`;